// remember to update reports
const EventType = {
  FREE_TEXT: 1,
  WITH_ATTACHMENT: 2,
  PENDENCY: 3,
  MONITORING_RESPONSE_ENABLED: 4,
  MONITORING_RESPONSE_DISABLED: 5,
  SOLVE_PENDENCY: 6,
  TASK: 7,
  SOLVE_TASK: 8,
  CLOSURE: 9,
  REOPEN: 10,
  COMMITTEE: 11,
  CLASSIFICATION: 12,
  EMPLOYEE_CREATED: 13,
  EMPLOYEE_UPDATED: 14,
  EMPLOYEE_DELETED: 15,
  TIME_COST: 16,
  DENOUNCED_UNLINK: 17, // Desvinculação de denunciado
  COURSE_ASSIGNMENT: 18, // Determinação de curso obrigatório
};

export default EventType;
